import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogModule,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { SharedTranslocoModule } from '@schaeffler/transloco';

import { ExcludedCalculationsButtonComponent } from './excluded-calculations-button/excluded-calculations-button.component';
import { ExcludedCalculationsDialogComponent } from './excluded-calculations-dialog/excluded-calculations-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatIconModule,
    MatTooltip,
    SharedTranslocoModule,
  ],
  declarations: [
    ExcludedCalculationsButtonComponent,
    ExcludedCalculationsDialogComponent,
  ],
  exports: [ExcludedCalculationsButtonComponent],
})
export class ExcludedCalculationsModule {}
